import { createContext, useContext, useState } from "react";
import { getRouteLinkIndexAdmin } from "../Functions/RouterFunction";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [state, setState] = useState(() => {
    const routerLink = getRouteLinkIndexAdmin();
    const storedToken = localStorage.getItem("authToken");
    return {
      loader: false,
      authToken: storedToken || false,
      userData: false,
      dashboardData: false,
      pageName: routerLink?.title || "Dashboard",
      pageLink: routerLink?.link || "/dashboard",
    };
  });
  const dispatch = (updates) => {
    setState((prevState) => {
      const newState = { ...prevState, ...updates };
      if (Object.prototype.hasOwnProperty.call(updates, "authToken")) {
        if (updates.authToken) {
          localStorage.setItem("authToken", updates.authToken);
        } else {
          localStorage.removeItem("authToken");
        }
      }
      return newState;
    });
  };
  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};